// @flow
import React from "react";
import AppHeader from "../components/AppHeader";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Helmet from "react-helmet";
import Button from "@material-ui/core/Button";
import { Link } from "@material-ui/core";
import PageSubHeading from "../components/PageSubHeading";

function Help() {
  return (
    <>
      <Helmet>
        <title>Hilfe - Sg Coesfeld 06</title>
      </Helmet>
      <AppHeader title={"Hilfe"} />
      <Container maxWidth="sm">
        <Box mb={2}>
          <Typography color="textSecondary">
            Wenn du Schwierigkeiten mit der Buchung oder
            Verbesserungsvorschläge für das System hast, schreib uns gerne eine
            kurze Nachricht:
          </Typography>
          <Box mt={2}>
            <Button
              onClick={() => {
                window.open(
                  "mailto:marianrick@gmail.com?subject=SG%20Coe%20Web%20App&body=Hi%2C",
                  "_blank"
                );
              }}
              variant="contained"
              color="primary"
            >
              E-Mail senden
            </Button>
          </Box>
        </Box>
        <Typography color="textSecondary" variant="caption">
          Version {process.env.REACT_APP_VERSION}
          <br />
          Erstellt von{" "}
          <Link
            onClick={() => {
              window.open("https://marianrick.de", "_blank");
            }}
          >
            Marian Rick
          </Link>
        </Typography>
        <PageSubHeading primary="Impressum" />
        <Typography color="textSecondary">
          Angaben gemäß § 5 TMG
          <br />
          <br />
          SportGemeinschaft Coesfeld 06 e.V.
          <br />
          Loburger Straße 30
          <br />
          48653 Coesfeld
          <br />
          <br />
          Vereinsregister: VR 121
          <br />
          Registergericht: Amtsgericht Coesfeld
          <br />
          <br />
          Vertreten durch den Vorstand:
          <br />
          Wolfgang Bodem (Anschrift wie oben)
          <br />
          <br />
          Kontakt
          <br />
          <br />
          Telefon: +49 2541 980666
          <br />
          Telefax: +49 2541 980667
          <br />
          E-Mail: info@sg-coesfeld.de
          <br />
          <br />
          Umsatzsteuer-ID
          <br />
          <br />
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
          <br />
          DE124470905
          <br />
          <br />
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          <br />
          <br />
          Wolfgang Bodem
          <br />
          Loburger Straße 30
          <br />
          48653 Coesfeld
          <br />
          <br />
          Streitschlichtung
          <br />
          <br />
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:
          https://ec.europa.eu/consumers/odr.
          <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
          <br />
          <br />
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </Typography>
      </Container>
    </>
  );
}

export default Help;
